import styled from "styled-components";

export const PlansAndPricingModalWrapper = styled.form`
  overflow: hidden;

  background: var(--color-background);

  padding: calc(var(--cardPadding) * 1.25);

  display: flex;
  flex-direction: column;

  gap: calc(var(--flexGap) * 1.2);

  border-radius: 1.5rem;

  width: min(100%);

  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.08),
    0 6px 18px rgba(0, 0, 0, 0.05);

  animation: modalEnter 0.22s ease;

  @keyframes modalEnter {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }

    to {
      opacity: 1;
      transform: translateY(0px) scale(1);
    }
  }

  legend {
    font-family: Inter;

    font-weight: 700;

    font-size: 2rem;

    text-align: center;

    margin-bottom: 0.5rem;

    padding-inline: 0;

    color: #1a1c1c;
  }

  fieldset {
    flex: 1;

    border: none;

    display: flex;
    flex-direction: column;

    gap: 0.5rem;
  }

  .modal-header {
    // margin-bottom: 1rem;
  }

  .modal-header > p {
    text-align: center;

    color: var(--color-text);

    line-height: 1.6;
  }

  .form-grid {
    display: grid;

    grid-template-columns: repeat(2, 1fr);

    gap: 1.25rem;
  }

  input {
    padding: 0.7rem 0.8rem;

    border-radius: 0.45rem;

    border: 1px solid var(--color-primary-hover);

    background-color: var(--color-button-secondary);

    font-weight: 500;

    transition: all 0.2s ease;

    outline: none;
  }

  input:focus {
    border: 1px solid var(--color-primary);
  }

  .submit-button-area {
    margin-top: 1rem;

    display: flex;
    flex-direction: column;

    gap: 1rem;
  }

  .close-modal-button-area {
    display: flex;
    justify-content: flex-end;
  }

  .close-modal-button {
    width: 42px !important;

    min-width: 42px;

    height: 42px;

    border-radius: 999px !important;

    padding: 0 !important;
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    padding: var(--cardPadding);

    .form-grid {
      grid-template-columns: 1fr;
    }

    legend {
      font-size: 1.5rem;
    }
  }
`;
